/**
 * API 설정 (dev/prod 프로파일)
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const API_CONFIG = {
  BASE_URL: isDevelopment
    ? process.env.REACT_APP_API_URL_DEV || 'http://localhost:8081/api'
    : process.env.REACT_APP_API_URL_PROD || 'https://api.sewoonch.com',

  TIMEOUT: 10000, // 30초 → 10초로 단축

  ENDPOINTS: {
    // 슬라이더
    SLIDER: '/slider',

    // 게시판
    BOARD: '/board',

    // 새가족
    NEW_FAMILY: '/new-family',

    // 설교 영상
    SERMON: '/sermon',

    // 관리자
    ADMIN: '/admin',
  },
} as const;
